import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const mutationDeleteVisitReport = {
  async deleteVisitReport(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.VISIT_REPORTS,
      operation: Operations.DELETE,
    })

    const config = AppSettings.sanityConfigByLang(lang)

    const client = context.sanityClient

    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    try {
      // make sure visit report exists and the id is actually of type visitReport
      const visitReport = await client.fetch(groq`*[_type=="visitReport" && _id==$id ${draftsFilter}][0] {...}`, {
        id: id,
      })

      if (!visitReport) return null

      const deleteReport = await client.delete(id)

      if (!deleteReport) return null

      return true
    } catch (error) {
      console.warn(error)
      return null
    }
  },
}
